import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Radio, Button, Row, Col } from 'antd';

class FormFilterRadio extends Component {
  _onValidate = (err, formValues) => {
    const { onSubmitForm } = this.props;
    if (!err) {
      const radioLabel = this.getOptionLabelByValue(formValues.radio);
      onSubmitForm(formValues.radio, radioLabel);
    }
  };

  getOptionLabelByValue = value => {
    const { options } = this.props;
    let result = null;

    for (let i = 0; i < options.length; i += 1) {
      if (options[i].value === value) {
        result = options[i].label;
        break;
      }
    }

    return result;
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  _renderForm = () => {
    const { options, onCancelForm } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col>
            <Form.Item required={false} colon={false}>
              {getFieldDecorator('radio', {
                rules: [
                  {
                    required: true,
                    message: 'select an option',
                  },
                ],
              })(
                <Radio.Group>
                  {options.map(item => (
                    <Radio
                      key={item.value}
                      value={item.value}
                      className="radio-style"
                    >
                      {item.label}
                    </Radio>
                  ))}
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>

          <Button className="btn cancel-btn" onClick={onCancelForm}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" className="btn">
            Submit
          </Button>
        </Row>
      </Form>
    );
  };

  render() {
    return <div>{this._renderForm()}</div>;
  }
}

FormFilterRadio.propTypes = {
  form: PropTypes.object,
  onCancelForm: PropTypes.func,
  onSubmitForm: PropTypes.func,
  options: PropTypes.array,
};

export default FormFilterRadio;
